import { useIsDesktop } from "common/MediaQueries"
import ModelTitleAndImage from "common/ModelTitleAndImage"
import { ShopTitle } from "common/ShopTypography"
import AccessoriesSidebar from "./AccessoriesSidebar"

const AccessoriesPage = () => {
  const isDesktop = useIsDesktop()
  return (
    <>
      {!isDesktop ? (
        <>
          <ShopTitle>הוספת אבזור</ShopTitle>
          <AccessoriesSidebar />
        </>
      ) : (
        <ModelTitleAndImage />
      )}
    </>
  )
}

export default AccessoriesPage
